export default "__VITE_ASSET__B0C971Nr__"